import Component from '@bythepixel/component-loader';
import Animations from '@Front/animations';

export default class SectionSliderController extends Component {
  static selector = '[data-comp-section-slider-controller]';

  sectionTitle;
  sectionBody;
  sectionCta;
  sectionCtaButton;

  constructor(containerEl, options = {}) {
    super(containerEl, options);

    this.#setAttributes();
    this.mount();
  }

  #setAttributes() {
    const { $container } = this;
    this.sectionTitle = $container.querySelector('.section-slider__header-title');
    this.sectionBody = $container.querySelector('.section-slider__header-body');
    this.sectionCta = $container.querySelector('.section-slider__header-cta');
    this.sectionCtaButton = $container.querySelector('.section-slider__header-cta .button--primary');
  }

  #attachSectionListeners() {
    const options = {
      rootMargin: '0px',
      threshold: 0.2,
    };

    const elements = [this.sectionTitle, this.sectionBody, this.sectionCta];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const { isIntersecting, target } = entry;
        const isCta = entry.target.dataset.compSectionSliderCta === 'true' || false;

        if (!isIntersecting) return;

        if (isIntersecting && target.classList.contains('invisible')) {
          Animations.maskRevealText(target);
          return;
        }

        if (isCta && isIntersecting) {
          const mask = entry.target.querySelector('.invisible');
          Animations.maskReveal(mask);
        }
      });
    }, options);

    elements.forEach(element => observer.observe(element));
  }

  mount() {
    this.#attachSectionListeners();
  }
}
